import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetDealerBirthDateDetailsQueryResponse } from '@models/reports/reports';
import { ReportsService } from '@services/reports.service';
import { firstValueFrom } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';

@Component({
  selector: 'app-birthdate-details-modal',
  templateUrl: './birthdate-details-modal.component.html',
  styleUrl: './birthdate-details-modal.component.scss'
})
export class BirthdateDetailsModalComponent extends ModalComponent<BirthdateDetailsModalComponent> implements OnInit {
  public loading: boolean;
  public form: FormGroup;
  public client: GetDealerBirthDateDetailsQueryResponse;

  public constructor(
    private readonly _reportsService: ReportsService,
    @Inject(MAT_DIALOG_DATA) public userId: number,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.loadClient();
  }

  public async loadClient(): Promise<void> {
    this.loading = true;
    const client = await firstValueFrom(this._reportsService.getBirthDateDetailsReportForUser(this.userId));

    this.client = client;
    this.loading = false;
  }
}
